export enum PaymentProviderType {
  TPAY = 'TPAY',
}
